import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Download, ExternalLink } from 'lucide-react';
import {
  ODOO_SLIDE_DECK_FILENAME,
  ODOO_SLIDE_DECK_URL,
  getOdooSlideDeckViewerUrl,
} from '../content/odooPartnership';

const OdooSlideDeckPage = () => {
  const viewerUrl = useMemo(
    () => getOdooSlideDeckViewerUrl(typeof window !== 'undefined' ? window.location.origin : undefined),
    []
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="sticky top-0 z-50 bg-[#FAFAF8]/95 backdrop-blur border-b border-[#E4EFD8]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-3">
          <Link
            to="/odoo"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#3B6D11] hover:text-[#27500A]"
          >
            <ArrowLeft className="h-4 w-4" />
            Partnership overview
          </Link>
          <div className="flex flex-wrap items-center gap-2 sm:gap-3">
            <a
              href={viewerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-[#3B6D11] hover:text-[#27500A]"
            >
              <ExternalLink className="h-4 w-4" />
              Open viewer in new tab
            </a>
            <a
              href={ODOO_SLIDE_DECK_URL}
              download={ODOO_SLIDE_DECK_FILENAME}
              className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 hover:text-[#3B6D11]"
            >
              <Download className="h-4 w-4" />
              Download
            </a>
          </div>
        </div>
      </header>

      <iframe
        title="Kolanut × Odoo slide deck"
        src={viewerUrl}
        className="flex-1 w-full min-h-[calc(100vh-3.5rem)] border-0 bg-white"
      />
    </div>
  );
};

export default OdooSlideDeckPage;
